/* eslint-disable react/prop-types */
import LineSetChart from 'common/components/Highcharts/LineSetChart';
import { IGenericWidgetDataSetProps } from 'common/module_interface/overview/Interface';

const LineSetWidget: React.FC<IGenericWidgetDataSetProps> = (props) => {
    const data = props;
    const className = props.data?.className;
    return (
        <div className={`@container flex flex-1 ${className}`}>
            <div className={`flex flex-col @[300px]:flex-row gap-5 py-6 px-8 flex-1 ${className}`}>
                <div className={'flex flex-1'}>
                    <LineSetChart data={data} key={props.widget?.title || ''} />
                </div>
            </div>
        </div>
    );
};

export default LineSetWidget;
